// extracted by mini-css-extract-plugin
module.exports = {"group":"_3t8e2JL","leftAlign":"_6rkyBTS","inline":"_3C8-Yvw"};